module.exports = __webpack_public_path__ + "img/portum.5d83ee7c.jpg";